export const NotificationTypes = Object.freeze({
  NONE: 'none',
  BANKRUPTCY: 'bankruptcy',
  DRAWDOWN_LIMIT: 'drawdown_limit'
});
